import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import _ from "lodash";
import queryString from "query-string";
import ToggleSwitch from "../../common/toggle_switch";

const ComparisonToggle = (props) => {
  const { queryParams, isToggled, previousPeriodAvailable } = props;

  const isHidden = useMemo(() => {
    return !previousPeriodAvailable;
  }, [previousPeriodAvailable]);

  const handleSelectComparisonTimeframe = useCallback(() => {
    const nextParams = {
      ...queryParams,
      previous_period: isToggled === true ? null : "true", // set search param to null if currently true
    };
    const nextParamsWithoutNulls = _.omitBy(nextParams, _.isNull);
    const search = queryString.stringify(nextParamsWithoutNulls);
    window.history.pushState({}, "", `?${search}`);
  }, [queryParams, isToggled]);

  return (
    !isHidden && (
      <ComparisonToggleContainer>
        <ToggleSwitch
          handleChange={handleSelectComparisonTimeframe}
          checked={isToggled}
        />
        <ComparisonLabel>Compare Previous Period</ComparisonLabel>
      </ComparisonToggleContainer>
    )
  );
};

const ComparisonToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ComparisonLabel = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: #000;
`;

ComparisonToggle.propTypes = {
  queryParams: PropTypes.shape({
    timeframe: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    id: PropTypes.string,
    project_id: PropTypes.string,
    team_id: PropTypes.string,
  }),
  isToggled: PropTypes.bool,
  previousPeriodAvailable: PropTypes.bool,
};

export default ComparisonToggle;
